import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import cn from "classnames";

export const FeatureSplit = ({
  className,
  title,
  heading,
  content,
  items,
  reverse,
  bgColor,
  buttonLink,
  buttonTitle,
  buttonNewTab,
}) => {
  return (
    <section
      className={cn(
        styles.FeatureSplit,
        className,
        reverse && styles.reverse,
        bgColor
      )}
    >
      <Container className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {title && <h2 data-sourceflow-prop="title" className={`${heading}`}>{title}</h2>}
            {content && (
              <div
                data-sourceflow-prop="content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            {buttonLink && buttonTitle && (
              <div className="mt-4">
                <a
                  href={buttonLink}
                  target={buttonNewTab ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  className="primaryBtn no-arrow m-0"
                  area-label={`${buttonTitle} - ${buttonLink.replace(/^\/+/, '').replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`}
                >
                  {buttonTitle}
                </a>
              </div>
            )}
          </div>
          <div className={styles.itemList}>
            {items?.map((item, i) => (
              <a
                href={item?.url || "#"}
                className={cn(
                  styles.item,
                  item.variant === "blueBlack"
                    ? styles.blueBox
                    : styles.blackBox
                )}
                key={i}
                target={item?.linkNewTab ? '_blank' : '_self'}
                rel="noopener noreferrer"
              >
                {item?.icon?.url && <img src={item.icon.url} alt="" />}
                <div className={styles.texts}>
                  <h4>{item.title}</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}
                  />
                </div>
                <i className="bi bi-arrow-right-circle-fill"></i>
              </a>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FeatureSplit;
